import React, { ChangeEvent } from 'react'
import { Input } from 'ui/input'

const CustomTimePicker = ({
    value,
    onChange,
    name
}: {
    value: string
    name: string | undefined
    onChange: (time: string) => void
}) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const newTime = event.target.value
        const [hours, minutes] = newTime.split(':')
        const currentValue = value || ''
        const [currentHours, currentMinutes] = currentValue.split(':')

        const updatedTime =
            newTime.length === 5
                ? newTime
                : hours
                  ? `${hours}:${currentMinutes || '00'}`
                  : minutes
                    ? `${currentHours || '00'}:${minutes}`
                    : currentValue

        onChange(updatedTime)
    }

    return (
        <div className='custom-time-picker'>
            <Input name={name ? name : 'date'} type='time' value={value || ''} onChange={handleChange} step='300' />
        </div>
    )
}

export default CustomTimePicker
